export default [
  {
    path: '/Music',
    meta: {
      title: '音乐上传'
    },
    component: () => import('../../view/Music/Music')
  }
]



// WEBPACK FOOTER //
// ./src/router/module/Music.js